<div class="user-profile-container">
  <div class="govuk-breadcrumbs">
    <ol class="govuk-breadcrumbs__list">
      <li class="govuk-breadcrumbs__list-item">
        <a *ngIf="this.isOrgAdmin && userName != ''" class="govuk-breadcrumbs__link" routerLink="/home">
            {{ 'ADMINISTRATOR_DASHBOARD' | translate }}
        </a>
        <a *ngIf="!this.isOrgAdmin && userName != ''" class="govuk-breadcrumbs__link"
            routerLink="/home">
            {{"PUBLIC_PROCUREMENT_GATEWAY_DASHBOARD" | translate}}
        </a>
        <a *ngIf="userName == ''" class="govuk-breadcrumbs__link" routerLink="/home">
            {{"REGITERATION_HOME" | translate}}
        </a>
      </li>
      <li class="govuk-breadcrumbs__list-item">
        <span class="govuk-breadcrumbs__link">Accessibility statement</span>
      </li>
    </ol>
  </div>
  <main id="main-content" role="main" class="govuk-main-wrapper" data-template="">
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">
        <h1 class="govuk-heading-xl page-title page-title--tight">
          Accessibility statement
        </h1>

        <p class="govuk-body-l"></p>
      </div>
    </div>

    <div class="page-components"></div>

    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">
        <div class="wysiwyg-content">
          <p>
            This website is run by Government Commercial Agency (GCA). We want as
            many people as possible to be able to use this website. For example,
            that means you should be able to:
          </p>
          <ul>
            <li>change colours, contrast levels and fonts</li>
            <li>zoom in up to 300% without the text spilling off the screen</li>
            <li>navigate most of the website using just a keyboard</li>
            <li>
              navigate most of the website using speech recognition software
            </li>
            <li>
              listen to most of the website using a screen reader (including the
              most recent versions of JAWS, NVDA and VoiceOver)
            </li>
          </ul>
          <p>
            We’ve also made the website text as simple as possible to
            understand.
          </p>
          <p>
            <a class="navigation-text" href="https://mcmw.abilitynet.org.uk/" target="_blank">AbilityNet</a>
            has advice on making your device easier to use if you have a
            disability.
          </p>
          <h3>How accessible this website is</h3>
          <p>We know some parts of this website are not fully accessible:</p>
          <ul>
            <li>1.3 - Adaptable: Create content that can be presented in different ways (for example simpler layout)
              without losing information or structure.</li>
            <li>
              1.4 - Distinguishable: Make it easier for users to see and hear content including separating foreground
              from background.
            </li>
            <li>
              2.1 - Keyboard Accessible: Make all functionality available from a keyboard.
            </li>
            <li>2.4 - Navigable: Provide ways to help users navigate, find content, and determine where they are.</li>
            <li>
              3.1 - Readable: Make content readable and understandable.
            </li>
            <li>
              3.2 - Predictable: Make Web pages appear and operate in predictable ways.
            </li>
            <li>
              3.3 - Input Assistance: Help users avoid and correct mistakes.
            </li>
            <li>
              4.1 - Compatible: Maximise compatibility with current and future user agents, including assistive
              technologies.
            </li>
          </ul>
          <h3>What to do if you cannot access parts of this website</h3>
          <p>
            If you need information on this website in a different format like
            accessible PDF, large print, easy read, audio recording or braille:
          </p>
          <ul>
            <li>
              email
              <a class="navigation-text" href="mailto:info@gca.gov.uk">info&#64;gca.gov.uk</a>
            </li>
            <li>call 0345 410 2222</li>
          </ul>
          <p>
            We’ll consider your request and get back to you in five working
            days.
          </p>
          <h3>Reporting accessibility problems with this website</h3>
          <p>
            We’re always looking to improve the accessibility of this website.
            If you find any problems not listed on this page or think we’re not
            meeting accessibility requirements, contact:
            <a class="navigation-text" href="mailto:info@gca.gov.uk">info&#64;gca.gov.uk.</a>
          </p>
          <h3>Enforcement procedure</h3>
          <p>
            The Equality and Human Rights Commission (EHRC) is responsible for
            enforcing the Public Sector Bodies (Websites and Mobile
            Applications) (No. 2) Accessibility Regulations 2018 (the
            ‘accessibility regulations’). If you’re not happy with how we
            respond to your complaint,
            <a class="navigation-text" href="https://www.equalityadvisoryservice.com/" target="_blank">contact the Equality Advisory and
              Support Service (EASS)</a>.
          </p>
          <h3>Technical information about this website’s accessibility</h3>
          <p>
            Government Commercial Agency is committed to making its website
            accessible, in accordance with the Public Sector Bodies (Websites
            and Mobile Applications) (No. 2) Accessibility Regulations 2018.
          </p>
          <p>
            This website is partially compliant with the
            <a class="navigation-text" target="_blank" href="https://www.w3.org/TR/WCAG21/">Web Content Accessibility Guidelines version
              2.1 AA standard,</a>
            due to the non-compliances listed below.
          </p>
          <h3>Non accessible content</h3>
          <p>
            The content listed below is non-accessible for the following
            reasons.
          </p>
          <h3>Non compliance with the accessibility regulations</h3>
          <div>
            <h4 class="govuk-heading-s">1.3.1 - Info and Relationships - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Using CSS to change the presentation of text to convey meaning without altering markup for
                assistive technologies. The error occurs in the Org title. Line 377 {{representingTag.LevelA}}</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">1.3.5 - Identify Input Purpose - Level AA</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Autocomplete attribute missing from password input field. Line 327</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">1.4.3 - Contrast (Minimum) - Level AA</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Colour contrast ratio failed for the Help and Support link.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">1.4.10 - Reflow - Level AA</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Page has a small overlap when sized down to minimum width. The beta banner overlaps the
                {{representingTag.LevelAA}} a little. Some users who are visually impaired prefer to try and consume
                content in one column. In this case no overlap of content should occur.</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">2.1.1 - Keyboard - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Clickable controls (as above {{representingTag.KeyboardLevelA}} links) do not have ARIA roles
                (role=link). ARIA roles help assistive technologies treat the element as something other than its native
                HTML element type.</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">2.4.1 - Bypass Blocks - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Iframes ID=rpiframe and ID=opiframe do not have title attributes.</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">2.4.2 - Page Titled - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - No title in {{representingTag.PageTitledLevelA}} tag.</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">2.4.6 - Headings and Labels - Level AA</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - 'Cancel' is ambiguous. Cancel returns to select a user. Be more descriptive. 'Add user',
                'Select a different user' or 'View Group' etc.</li>
              <li>Fix - This is currently planned for improvement in forthcoming development</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">3.1.1 - Language of page - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - No lang attribute on rplFrame.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">3.2.4 - Consistent Identification - Level AA</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - The actions on this page are present as hyperlinks rather than buttons despite them being
                actions rather than links.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">3.3.1 - Error Identification - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Include additional Group name validation.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">3.3.2 - Labels or Instructions - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - The submit button is disabled when the page is first loaded, but on a page where there is a
                minimum set of fields required, this gives a false sense of validity.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">3.3.3 - Error Suggestion Level AA</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - There are required fields, but these are not indicated to the user until the user attempts to
                click submit.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <div>
            <h4 class="govuk-heading-s">4.1.1 - Parsing - Level A</h4>
            <ul class="govuk-list govuk-list--bullet">
              <li>Issue - Document has focusable elements with the same ID. Btn-login and btn-cancel.</li>
              <li>Fix - This is currently being analysed to confirm the required resolution.</li>
            </ul>
          </div>
          <h3>How we tested this website</h3>
          <p>
            <span>This website was last tested on 4 April 2022. The test was carried out by Kainos.</span><br><br>
            <span>We tested:</span><br><br>
            <span>All pages that are currently available within the Public Procurement Gateway (PPG).</span>
          </p>
          <h3>What we’re doing to improve accessibility</h3>
          <p>
            We have created a backlog to remediate all accessibility issues on this site, and on other GCA sites. We are
            also working with our third party suppliers to ensure they build and design to WCAG 2.1 AA standards from
            now on.
          </p>
          <p>
            We plan to fix all accessibility issues on this website in our next phase of website improvement works, due
            for completion in October 2022.
          </p>
          <p>This statement was prepared on 14 April 2022.</p>
        </div>
      </div>
    </div>

    <div class="govuk-grid-row">
      <div class="govuk-grid-column-full">
        <div class="wysiwyg-content"></div>
      </div>
    </div>

    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">
        <div class="app-c-print-link">
          <button (click)="print('Print this page');" type="button" class="app-c-print-link__link navigation-text print_Screen"
            rel="alternate">
            Print this page
          </button>
        </div>
      </div>
    </div>
  </main>
</div>